module.exports = __webpack_public_path__ + "img/thumbnail_WesternLowlandGorilla_j_normal.db19c2c9.png";